import axios from 'axios'

// 获取物品分类列表（不分页）
export function getItemTypeList(params) {
  return axios.get(process.env.VUE_APP_BASE_API +'/itemType/list', { params })
}

// 获取单个分类
export function getItemType(id) {
  return axios.get(process.env.VUE_APP_BASE_API + `/itemType/get/${id}`)
}

// 新增分类
export function addItemType(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/itemType/add', data)
}

// 修改分类
export function updateItemType(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/itemType/update', data)
}

// 删除分类（POST）
export function deleteItemType(id) {
  return axios.post(process.env.VUE_APP_BASE_API + `/itemType/delete/${id}`)
}

export default {
  getItemTypeList,
  getItemType,
  addItemType,
  updateItemType,
  deleteItemType
}
